import { useQuery } from "@tanstack/react-query";
import algoliasearch from "algoliasearch/lite";
import { useDebounceValue } from "usehooks-ts";

interface FernDocHit {
  title: string;
  pathname: string;
  description?: string;
  content?: string;
}

export default function useSearchDocs(query: string) {
  const [debouncedQuery] = useDebounceValue(query, 500);

  const searchIndex = useQuery({
    queryKey: ["searchIndex"],
    queryFn: async () => {
      const response = await fetch(
        "https://www.alchemy.com/docs/api/fern-docs/search/v2/key",
      );

      if (!response.ok) {
        throw new Error("Failed to fetch search index");
      }

      return (await response.json()) as { appId: string; apiKey: string };
    },
    select: ({ appId, apiKey }) =>
      algoliasearch(appId, apiKey).initIndex("fern_docs_search"),
  });

  return useQuery({
    queryKey: ["search", query],
    queryFn: () => searchIndex.data?.search<FernDocHit>(query),
    enabled: !!searchIndex.data && debouncedQuery === query,
    select: (data) =>
      data?.hits.map((hit) => ({
        label: hit.title,
        description: hit.description || hit.content,
        to: `https://alchemy.com${hit.pathname}`,
      })),
  });
}
